import { CustomVideoPlayer } from '@room-match/shared-ui-components';
import React from 'react';
import { ICastingRoleAttributes } from 'shared/interfaces/ICastingRole';
import { getCleanStringWithCommas } from 'shared/utils/getCleanStringWithCommas';
import { ellipseText, readableProjectUnion, secondsToTime } from 'shared/utils/room-shared';

import RefFiles from 'shared/components/RefFiles/RefFiles';
import {
  Content,
  Heading,
  MainContainer,
  MediaList,
  PlainHeading,
  ScrollableContainer,
  TextGreyColor,
  TextSwitchColor,
  VideoItemCont,
} from './RoleDetails.styles';

interface Props {
  data: ICastingRoleAttributes | undefined;
  headshotUrl?: string | null;
}
const RoleDetails: React.FC<Props> = ({ data, headshotUrl }) => {
  return (
    <MainContainer>
      <Heading fontSize={18}>Your Role detail, instructions and scenes/sides</Heading>
      <Content>
        <div>
          {headshotUrl && (
            <div>
              <PlainHeading fontWeight={500} style={{ color: '#f7bc02' }}>
                Photo submitted by your representative:
              </PlainHeading>
              <img src={headshotUrl} style={{ width: '100%', maxWidth: 250, display: 'block', margin: '20px auto' }} />
            </div>
          )}
          {/* <Typography fontSize={15} style={{ whiteSpace: 'break-spaces' }}>
            {data?.self_tapes_requirements?.selections || data?.talent_description || '–'}
          </Typography> */}
          {data?.self_tapes_requirements?.selections || data?.talent_description ? (
            <>
              <PlainHeading fontWeight={500} style={{ color: '#f7bc02' }}>
                Direction:
              </PlainHeading>
              <TextSwitchColor size={15} withBreakSpaces={true}>
                {data?.self_tapes_requirements?.selections || data?.talent_description}
              </TextSwitchColor>
            </>
          ) : null}
        </div>
        {data && data.self_tapes_directions && (
          <ScrollableContainer>
            {data?.self_tapes_directions.map((i) => (
              <div>
                <VideoItemCont>
                  {/* <VideoItem url={i.media?.attachment || ''} /> */}
                  <CustomVideoPlayer url={i.media?.attachment || ''} isSmall />
                </VideoItemCont>
                {/* <Typography fontSize={14}>{ellipseText(i.description, 16)}</Typography> */}
                {/* <Typography color="mainGrey" fontSize={14}>
                  {secondsToTime(Number(i.media?.duration || 0))}
                </Typography> */}
                <TextSwitchColor size={14}>{i.description}</TextSwitchColor>
                <TextGreyColor size={14}>
                  {!isNaN(Number(i.media?.duration)) ? secondsToTime(Number(i.media?.duration || 0)) : 0}
                </TextGreyColor>
              </div>
            ))}
          </ScrollableContainer>
        )}
        <div>
          <PlainHeading color="primary" fontWeight={500}>
            Role Information:
          </PlainHeading>
        </div>
        <div>
          <TextGreyColor size={14}>Role Name</TextGreyColor>
          <TextSwitchColor size={16}>{data?.name || '–'}</TextSwitchColor>
        </div>
        <div>
          <TextGreyColor size={14}>Role Gender</TextGreyColor>
          <TextSwitchColor size={16}>
            {data && data.genders?.length ? getCleanStringWithCommas(data.genders.toString()) : '–'}
          </TextSwitchColor>
        </div>
        <div>
          <TextGreyColor size={14}>Age Range</TextGreyColor>
          <TextSwitchColor size={16}>
            {data?.age_range_from && data.age_range_to ? `${data.age_range_from} - ${data.age_range_to}` : '–'}
          </TextSwitchColor>
        </div>
        <div>
          <TextGreyColor size={14}>Role Type</TextGreyColor>
          <TextSwitchColor size={16}>{data?.audition_type === 'studio' ? 'Studio' : 'Self-tapes'}</TextSwitchColor>
        </div>
        {data?.project?.union ? (
          <div>
            <TextGreyColor size={14}>Union</TextGreyColor>
            <TextSwitchColor size={16}>
              {data?.project.union ? readableProjectUnion(data.project.union) : '–'}
            </TextSwitchColor>
          </div>
        ) : null}

        {data && data?.self_tapes_requirements && (
          <div>
            <PlainHeading style={{ color: '#f7bc02' }} fontWeight={500}>
              Media Required:
            </PlainHeading>

            <MediaList>
              {!!data.self_tapes_requirements.audition_selfie && (
                <TextSwitchColor size={16}>1x Image (Audition Selfie)</TextSwitchColor>
              )}
              {!!data.self_tapes_requirements.full_body && (
                <TextSwitchColor size={16}>1x Image (Full Body)</TextSwitchColor>
              )}
              {data.self_tapes_requirements.other_images?.length > 0 && (
                <TextSwitchColor size={16}>{`${data.self_tapes_requirements.other_images?.length}${
                  data.self_tapes_requirements.other_images?.length === 1
                    ? 'x Image (Other Image)'
                    : 'x Images (Other Images)'
                }`}</TextSwitchColor>
              )}
              {data.self_tapes_requirements.audio?.length > 0 && (
                <TextSwitchColor size={16}>{`${data.self_tapes_requirements.audio?.length}${
                  data.self_tapes_requirements.audio?.length === 1 ? 'x Audio' : 'x Audios'
                }`}</TextSwitchColor>
              )}
              {!!data.self_tapes_requirements.slate && <TextSwitchColor size={16}>1x Slate</TextSwitchColor>}
              {data.self_tapes_requirements.video?.length > 0 && (
                <TextSwitchColor size={16}>{`${data.self_tapes_requirements.video?.length}${
                  data.self_tapes_requirements.video?.length === 1 ? 'x Video' : 'x Videos'
                }`}</TextSwitchColor>
              )}
              {data.self_tapes_requirements.files?.length > 0 && (
                <TextSwitchColor size={16}>{`${data.self_tapes_requirements.files?.length}${
                  data.self_tapes_requirements.files?.length === 1
                    ? 'x Scene (Side Attached)'
                    : 'x Scenes (Sides Attached)'
                }`}</TextSwitchColor>
              )}
            </MediaList>
          </div>
        )}
        {data && ((data?.photos as any) || (data?.sides as any)).length > 0 && (
          // <div>
          //   <PlainHeading color="primary" fontWeight={500}>
          //     Ref Images/Files:
          //   </PlainHeading>

          //   <>
          //     {data.photos?.data?.length > 0 && (
          //       <ScrollableContainer>
          //         {data.photos.data.map((i) => (
          //           <MediaItem src={i.attributes.modified_attachment || i.attributes.attachment} />
          //         ))}
          //       </ScrollableContainer>
          //     )}
          //     {data.project.medium_attachments.filter((v) => v.medium.file_type === 'Document')?.length > 0 && (
          //       <ScrollableContainer>
          //         {data.project.medium_attachments
          //           .filter((v) => v.medium.file_type === 'Document')
          //           .map((i) => (
          //             <FileItem onClick={() => window.open(`${i.attachment}`, '_blank')}>
          //               <DocumentFileIcon />
          //               <Typography fontSize={12}>{i.medium.file_name}</Typography>
          //             </FileItem>
          //           ))}
          //       </ScrollableContainer>
          //     )}
          //   </>
          // </div>
          <RefFiles
            audio={((data.sides as any) || []).filter((v: any) => v.medium.file_type.toLowerCase() === 'audio')}
            videos={((data.sides as any) || []).filter((v: any) => v.medium.file_type.toLowerCase() === 'video')}
            docs={((data.sides as any) || []).filter((v: any) => v.medium.file_type.toLowerCase() === 'document')}
            photos={(data.photos as any) || []}
            links={data.reference_urls || []}
          />
        )}
      </Content>
    </MainContainer>
  );
};

export default RoleDetails;
